import React from 'react';
import { useTranslation } from 'react-i18next';

import { type MarketBoxes } from '@/common/types/shop/marketBoxes';
import { ShopTitle } from '@/components/Shop/ui/ShopUi';
import { useAppSelector } from '@/redux/store';

import { BigPackCard, SmallPackCard } from './PackCard';

const smallPacks: MarketBoxes[] = ['free', 'ads'];
const bigPacks: MarketBoxes[] = ['starter', 'pro', 'gold', 'elit'];

/** "Packs" tab of the shop: only the packs /shop/info returns. */
const BoxMarket: React.FC = () => {
  const { t } = useTranslation();
  const boxList = useAppSelector((state) => state.shop.shopPacks) ?? [];
  const byName = (names: MarketBoxes[]): typeof boxList =>
    names.flatMap((name) => boxList.filter((box) => box.name === name));

  const small = byName(smallPacks);
  const big = byName(bigPacks);

  return (
    <div className="w-full flex flex-col items-center gap-6 px-4 pt-4 pb-6">
      <ShopTitle>{t('Full Supply Packs')}</ShopTitle>
      {!!small.length && (
        <div className="flex gap-4 w-full">
          {small.map((box) => (
            <SmallPackCard key={box.name} {...box} />
          ))}
        </div>
      )}
      {big.map((box) => (
        <BigPackCard key={box.name} {...box} />
      ))}
    </div>
  );
};

export default BoxMarket;
